import Model from '../../ModelBinding/Model';
import RateFormCollection from './RateFormCollection';
import RateFormGroupCollection from '../RateFormGroup/RateFormGroupCollection';

export default class RateForm extends Model {
  public name?: string;
  public target_type?: string;
  public groups?: RateFormGroupCollection;
  public product_type_code?: string;

  static rootUri = 'rates';

  bind() {
    this.name = this.getStringAttribute('name');
    this.target_type = this.getStringAttribute('target_type');
    this.product_type_code = this.getStringAttribute('product_type_code');
    this.groups = this.getRelationCollection('groups', RateFormGroupCollection) as RateFormGroupCollection;
  }

  static getCollection() {
    return RateFormCollection;
  }
}
